
import React from 'react'
import { H1 } from './styles'

export function CustomTitle({title}){	
	return <H1>{ title }</H1>
}
